'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

var _feiseanna = require('ifeis-isomorphic/lib/redux/actions/feiseanna');

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AGE_STRING_REGEXP = /^([uo])?(\d+)&?(o|u)?$/i;

/**
 * Return an age object from a string age.
 */
function ageFromString(str) {
  var matches = str.match(AGE_STRING_REGEXP);
  var age = {};

  if (matches) {
    age.number = parseInt(matches[2], 10);

    age.exclusive = matches[1] ? 1 : 0;
    age.inclusive = matches[3] ? 1 : 0;

    if (matches[1] && matches[1].toLowerCase() === 'u') {
      age.direction = -1;
    } else if (matches[1] && matches[1].toLowerCase() === 'o') {
      age.direction = 1;
    } else if (matches[3] && matches[3].toLowerCase() === 'u') {
      age.direction = -1;
    } else if (matches[3] && matches[3].toLowerCase() === 'o') {
      age.direction = 1;
    } else {
      age.direction = 0;
    }
  }

  return age;
}

var EventEditorController = function () {
  function EventEditorController($q, $scope, $ngRedux, $mdDialog, syllabusActions, fEventService, fRegistrationService, event_id, feis_id, tpl, options, msgService) {
    var _this = this;

    _classCallCheck(this, EventEditorController);

    var getFeisAge = fRegistrationService.getFeisAge;


    this.tabIndex = 0;
    this.options = _extends({
      split: event_id ? true : false
    }, options);
    this.disconnect;

    if (this.options.split) {
      $q.all([$ngRedux.dispatch((0, _feiseanna.getFeis)(feis_id)), $ngRedux.dispatch((0, _feiseanna.getEventLevels)(feis_id)), $ngRedux.dispatch((0, _feiseanna.getEventTypes)(feis_id)), $ngRedux.dispatch((0, _feiseanna.getGroupFeesForFeis)(feis_id)), $ngRedux.dispatch((0, _events.getGroupFeeAssignedToEvent)(feis_id, event_id)), $ngRedux.dispatch((0, _events.getParticipants)(feis_id, event_id))]).then(function () {
        $ngRedux.connect((0, _mapStateToController2.default)(feis_id, event_id, tpl, _this.options.merge))(_this);
      });
    } else {
      $q.all([$ngRedux.dispatch((0, _feiseanna.getFeis)(feis_id)), $ngRedux.dispatch((0, _feiseanna.getEventLevels)(feis_id)), $ngRedux.dispatch((0, _feiseanna.getEventTypes)(feis_id)), $ngRedux.dispatch((0, _feiseanna.getGroupFeesForFeis)(feis_id)), $ngRedux.dispatch((0, _events.getGroupFeeAssignedToEvent)(feis_id, event_id))]).then(function () {
        $ngRedux.connect((0, _mapStateToController2.default)(feis_id, event_id, tpl, _this.options.merge)).bind(_this)(_this);
      });
    }

    this._ = {
      $mdDialog: $mdDialog,
      msgService: msgService,
      dispatch: function dispatch() {
        return $ngRedux.dispatch.apply($ngRedux, arguments);
      }
    };

    if (this.options.merge) {
      this.merging = true;
      this.editing = false;
    }
  }

  _createClass(EventEditorController, [{
    key: 'personChecked',
    value: function personChecked(id) {
      return this.selectedParticipants.includes(id);
    }
  }, {
    key: 'checkPerson',
    value: function checkPerson(id) {
      if (this.personChecked(id)) {
        this.selectedParticipants = this.selectedParticipants.filter(function (i) {
          return i !== id;
        });
      } else {
        this.selectedParticipants = this.selectedParticipants.push(id);
      }
    }
  }, {
    key: 'isLoading',
    value: function isLoading() {
      var feisLoading = this.feis ? this.feis.get('loading') : true;
      var eventLoading = this.event ? this.event.loading : true;
      return this.loading || feisLoading || eventLoading || this._isSaving;
    }
  }, {
    key: 'updateType',
    value: function updateType() {
      var _this2 = this;

      this.type = this.types.find(function (t) {
        return t.value === _this2.event.type;
      });
      if (this.type.hasLevels && !this.event.level) {
        this.selectFirstEventLevels();
      } else if (!this.type.hasLevels) {
        this.event.level = undefined;
      }
    }
  }, {
    key: 'selectFirstEventLevels',
    value: function selectFirstEventLevels() {
      this.event.level = this.eventLevels[0].value;
    }
  }, {
    key: '_parseGroupFee',
    value: function _parseGroupFee(groupFeeObj, groupFees) {
      if (!groupFeeObj || groupFeeObj === '') {
        return {};
      }
      var groupFeeObjJson = JSON.parse(groupFeeObj);

      if (Object.keys(groupFeeObjJson).length == 0) {
        return {};
      }

      return groupFees.find(function (g) {
        return g.get('id') === groupFeeObjJson.id;
      }).toJS();
    }
  }, {
    key: 'clearEventFee',
    value: function clearEventFee() {
      this.event.fee = undefined;
      if (!this.groupFeeObj) {
        this.event.groupFeeId = undefined;
      }
    }
  }, {
    key: 'updateEventFee',
    value: function updateEventFee(groupFeeObj, groupFees, eventGroupFee) {
      var matchingGroupFeeObj = this._parseGroupFee(groupFeeObj, groupFees);
      if (Object.keys(matchingGroupFeeObj).length > 0 && matchingGroupFeeObj.id !== eventGroupFee.get('id')) {
        return this._.dispatch((0, _events.updateGroupFeeAssignedToEvent)(this.feis.get('id'), this.event.id, { id: matchingGroupFeeObj.id }));
      } else if (eventGroupFee.size > 0 && Object.keys(matchingGroupFeeObj).length === 0) {
        return this._.dispatch((0, _events.deleteGroupFeeAssignedToEvent)(this.feis.get('id'), this.event.id));
      }
    }
  }, {
    key: 'addEventFee',
    value: function addEventFee(groupFeeObj, eventId) {
      if (!groupFeeObj || groupFeeObj === '') {
        return this._.dispatch((0, _events.deleteGroupFeeAssignedToEvent)(this.feis.get('id'), eventId));
      }
      var groupFeeObjJson = JSON.parse(groupFeeObj);
      return this._.dispatch((0, _events.updateGroupFeeAssignedToEvent)(this.feis.get('id'), eventId, { id: groupFeeObjJson.id }));
    }

    // FIXME(joshdmiller): should be a pure function

  }, {
    key: '_prepFields',
    value: function _prepFields() {
      if (!this.type.hasLevels) {
        this.event.level = undefined;
      }

      this.event.age_min = this.event.age_min || undefined;
      this.event.age_max = this.event.age_max || undefined;

      if (this.placementsCalculation !== 'PCT') {
        delete this.event.place_pct;
      }

      if (this.placementsCalculation !== 'CNT') {
        delete this.event.place_cnt;
      }

      if (this.placementsCalculation !== 'NAFCorPercent') {
        delete this.event.nafc_or_place_pct;
      }

      if (this.placementsCalculation !== 'NAFCorNumber') {
        delete this.event.nafc_or_place_cnt;
      }

      if (!this.restrictGender) {
        delete this.event.gender;
      }

      if (!this.customFee) {
        delete this.event.fee;
        delete this.groupFeeObj;
      }

      var parsedObj = JSON.parse(this.groupFeeObj || '{}');
      if (this.customFee && Object.keys(parsedObj).length > 0) {
        delete this.event.fee;
      }

      if (!this.medalRounds) {
        delete this.event.medalRounds;
      }

      if (this.event.adults === 1) {
        delete this.event.age_max;
        this.event.age_min = 18;
        this.event.age = '18&O';
      }
    }
  }, {
    key: 'updateAgeBracket',
    value: function updateAgeBracket() {
      if (!this.event.age) {
        return;
      }

      var age = ageFromString(this.event.age);

      if (age.direction === 0) {
        this.event.age_min = this.event.age_max = age.number;
      }
    }
  }, {
    key: 'throwError',
    value: function throwError(msg) {
      this._.msgService.displayErrorMsg(msg);
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this._.$mdDialog.cancel();
    }
  }, {
    key: 'save',
    value: function save() {
      var _this3 = this;

      var feis_id = this.feis.get('id');
      var promise = void 0;
      this.isSaving = true;
      this._prepFields();
      var groupFeeObj = this.groupFeeObj;
      var groupFees = this.groupFees;
      var eventGroupFee = this.eventGroupFee;

      if (this.editing) {
        var currentEvent = this.event;
        promise = this._.dispatch((0, _events.updateEvent)(feis_id, this.event.id, currentEvent)).then(function (res) {
          if (res.errors) {
            return Promise.reject(res.errors);
          } else {
            _this3.updateEventFee(groupFeeObj, groupFees, eventGroupFee, true);
          }
        });
      } else if (this.splitting) {
        promise = this._.dispatch((0, _events.splitEvent)(feis_id, this.fromEvent.id, this.fromEvent, this.oldComps, this.event, this.newComps)).then(function (res) {
          _this3.addEventFee(groupFeeObj, res.payload[0].id);
          _this3.addEventFee(groupFeeObj, res.payload[1].id);
        });
      } else if (this.merging) {
        var _options$merge = this.options.merge,
            a = _options$merge.a,
            b = _options$merge.b;


        promise = this._.dispatch((0, _events.mergeEvents)(feis_id, a.get('id'), b.get('id'), this.event)).then(function (res) {
          return _this3.addEventFee(groupFeeObj, res.payload.id);
        });
      } else {
        promise = this._.dispatch((0, _events.createEvent)(feis_id, this.event)).then(function (res) {
          return _this3.addEventFee(groupFeeObj, res.payload.id);
        });
      }
      // if ( this.merging ) {
      //   return this._.syllabusActions.merge( this.options.merge.a, this.options.merge.b, this.event ).then(
      //     res => this._.$mdDialog.hide(),
      //     err => this._.msgService.displayErrorMsg(err)
      //   ).finally( () => this.isLoading = false );
      // }

      return promise.then(function () {
        return _this3._.$mdDialog.hide();
      }).catch(function (err) {
        _this3._.$mdDialog.hide();
        _this3._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'getMedalRounds',
    value: function getMedalRounds() {
      if (this.event.medalRounds > this.event.rounds) {
        this.event.medalRounds = parseFloat(this.event.rounds);
      } else {
        this.event.medalRounds = parseFloat(this.event.medalRounds);
      }
    }
  }, {
    key: 'duplicate',
    value: function duplicate() {
      if (this.event.name === this.originalEventName) {
        return this.throwError('You must change the competition number to duplicate an event');
      }

      delete this.event.id;
      this.editing = false;
      return this.save();
    }
  }, {
    key: 'remove',
    value: function remove() {
      var _this4 = this;

      return this._.dispatch((0, _events.deleteEvent)(this.feis.get('id'), this.event.id)).then(function () {
        return _this4._.$mdDialog.hide();
      }).catch(function (err) {
        return _this4._.msgService.displayErrorMsg(err);
      });
    }
  }, {
    key: 'split',
    value: function split() {
      var _this5 = this;

      this.newComps = this.selectedParticipants.toJS();
      this.oldComps = this.participants.map(function (p) {
        return p.get('id');
      }).filter(function (id) {
        return !_this5.personChecked(id);
      }).toJS();

      if (this.newComps.length < 1) {
        return this.throwError('You must select some competitors for the new event.');
      }

      if (this.oldComps.length < 1) {
        return this.throwError('You must leave some competitors for this event.');
      }

      this.fromEvent = _extends({}, this.event);
      delete this.event.id;
      this.event.name = this.event.name + '-split';

      this.editing = false;
      this.splitting = true;
      this.options.split = false;
      this.tabIndex = 0;

      this.save();
    }
  }, {
    key: 'searchArray',
    value: function searchArray(arr, searchText) {
      return arr.filter(function (element) {
        return element.toLowerCase().includes(searchText.toLowerCase());
      });
    }
  }]);

  return EventEditorController;
}();

exports.default = _angular2.default.module('ifeis.syllabi.editor', ['ngMaterial', 'ifeis.events', 'ifeis.syllabi.store', 'ifeis.syllabi.actions']).factory('fEventEditor', function ($mdDialog, $mdMedia) {
  return function (ev, feis_id, event_id, tpl, options) {
    return $mdDialog.show({
      controller: EventEditorController,
      controllerAs: 'editor',
      template: require('./tpl.html'),
      targetEvent: ev,
      locals: {
        feis_id: feis_id,
        event_id: event_id,
        tpl: tpl,
        options: options
      },
      parent: _angular2.default.element(document.body),
      clickOutsideToClose: true,
      fullscreen: $mdMedia('sm') || $mdMedia('xs')
    });
  };
}).directive('ageLabel', function () {
  return {
    require: 'ngModel',
    link: function link(scope, elm, attrs, ctrl) {
      ctrl.$validators.ageRange = function (modelValue, viewValue) {
        if (ctrl.$isEmpty(modelValue)) {
          return true;
        }

        if (AGE_STRING_REGEXP.test(viewValue)) {
          return true;
        }

        return false;
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./syllabus/editor/index.js
// module id = 222
// module chunks = 0